export const PROVIDERS = {
  TURNITIN: 'turnitin',
  HANDIN: 'hand-in',
  QUIZZES: 'quizzes',
};

export default {
  PROVIDERS,
};
